var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhitelogouticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0426 25.5602C10.4748 26.1051 9.57286 26.0865 9.02796 25.5187L2.3976 18.6099C1.86847 18.0585 1.86847 17.188 2.3976 16.6366L9.02796 9.72772C9.57286 9.16002 10.4748 9.1414 11.0426 9.6863C11.6103 10.2312 11.629 11.1333 11.0841 11.701L6.76857 16.1979L20.0067 16.1979C20.7936 16.1979 21.4316 16.8359 21.4316 17.6229C21.4316 18.4098 20.7936 19.0478 20.0067 19.0478L6.76781 19.0478L11.0841 23.5454C11.629 24.1132 11.6103 25.0153 11.0426 25.5602Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.25 32.8231C35.25 33.6101 34.612 34.248 33.8251 34.248L15.8622 34.248C15.075 34.248 14.4372 33.6101 14.4372 32.8231L14.4372 27.1233C14.4372 26.3363 14.4372 24.6984 16.5 24.6984C18.2871 24.6984 18.2871 26.3363 18.2871 27.1233L18.2871 30.3982L31.4001 30.3982L31.4001 4.8492L18.2871 4.8492L18.2871 8.12404C18.2871 8.91099 17.9249 10.4993 16.5 10.4993C14.4372 10.4993 14.4372 8.91099 14.4372 8.12404L14.4372 2.42426C14.4372 1.63731 15.0751 0.999312 15.8622 0.999312L33.8251 0.999313C34.612 0.999313 35.25 1.63731 35.25 2.42426L35.25 32.8231Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitelogouticon);
export default __webpack_public_path__ + "static/media/whitelogouticon.45ddfa6374e611c65b16707471517496.svg";
export { ForwardRef as ReactComponent };